import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TTMMapResponse } from '../models/ttm-map.model';

@Injectable({
  providedIn: 'root'
})
export class ExploreModeService {
  private sampleConfigUrl = "https://dev-dexcat.alpha.simadvisory.com/v1/dexcat/explore-mode/inbound/sample-file";
  private ttmApiUrl = 'https://dev-dexcat.alpha.simadvisory.com/v1/dexcat/explore-mode/inbound/ttm-map';

  constructor(private http: HttpClient) {}

  uploadSampleFile(file: File): Observable<any> {
    const formData = new FormData();
    formData.append('sample_file', file);
    return this.http.post(this.sampleConfigUrl, formData);
  }

  downloadTTMMap (sessionid: string): Observable<TTMMapResponse> {
    const requestPayload = {session_id: sessionid };
    return this.http.post<TTMMapResponse>(this.ttmApiUrl, requestPayload);
  }

  SaveTTMMap(sessionid: string, apiPayload: any): Observable<TTMMapResponse> {
  const requestPayload = {
    session_id: sessionid,
    ttm_map: apiPayload
  };
  return this.http.put<TTMMapResponse>(this.ttmApiUrl, requestPayload);
}

}
